import React, { useState, useEffect, lazy, Suspense } from "react";
import { Tabs, Tab } from "react-bootstrap";
import "./ClientProgress.css";
// import Gantt from "../Gantt/gantt";
// import Dashboard from "../dashboard/dashboard";
import _ from 'lodash';
import DealList from "../../components/Deal/DealList";
import SkeletonUIHeader from "../../components/ProjectTasks/SkeletonUIHeader";

const ProjectTasks = lazy(() =>
  import("../../components/ProjectTasks/ProjectTasks")
);

const ClientProgress = (props) => {
    const [key, setKey] = useState("deals");
    const [accountDeals, setAccountDeals] = useState([]);
    const [DealsId, setDealsId] = useState("");
    // useEffect(() => {
    //     if (props.dealObj.Project_ID) {
    //         setDealsId(props.dealObj.Project_ID);
    //     }
    // }, [props.dealObj]);
    // const getDealObj=(clone)=>{
    //     let dealObj=_.cloneDeep(clone);
    //     delete dealObj.zoningList;
    //     delete dealObj.commercialList;
    //     delete dealObj.specialDistList;
    //     return dealObj
    // }
    return (
        <div>
            <Tabs
                style={key == 'milestones' ? { marginBottom: '12px' } : {}}
                id="progress-tabs"
                activeKey={key}
                onSelect={(k) => setKey(k)}
                className="job-middle-tab job-middle-tabs progress-inner-tabs"
            >
                <Tab eventKey="deals" title="Deals">
                    <DealList
                        setCheckType={props.setCheckType}
                        checkType={props.checkType}
                        selectedIds={props.selectedIds}
                        setSelectedIds={props.setSelectedIds}
                        deleteDealFlag={props.deleteDealFlag}
                        setDeleteDealFlag={props.setDeleteDealFlag}
                        dealLocation={"Accounts"}
                        data={props.data}
                        params={props.params}
                        setAccountDeals={setAccountDeals}
                        history={props.history}
                        location={props.location} />
                </Tab>
                <Tab className={"client-body-task"} eventKey="tasks" title="Tasks">
                    {key === "tasks" && (<Suspense fallback={<SkeletonUIHeader/>}>
                    <ProjectTasks 
                               checkType = {props.checkType}
                               setCheckType = {props.setCheckType}
                               dealListStatus = {""}
                               dealListTriggers = {()=>{}}
                               getParams = {props.getParams}
                               location = {props.location}
                               history =  {props.history}
                               fromBody =  {true}
                               dealObj = {accountDeals}
                               setTasksForDeal = {()=>{}}
                              />
                              </Suspense>)}
                       {/* <TaskListWithDeal
                      //  history={props.history}
                        // setTimerPrevTimeTrack={props.setTimerPrevTimeTrack}
                        // startstopClockTimeTrack={props.startstopClockTimeTrack}
                        // setTimerTimeTrack={props.setTimerTimeTrack}
                        // timerTimeTrack={props.timerTimeTrack} 
                        // initializeTimeTrack={props.initializeTimeTrack}
                        //taskLoaction={"Accounts"} data={props.data} /> */}
                </Tab>
                {/* <Tab eventKey="gantt" title="Gantt & Reports">
            Gantt Reports
        </Tab>
        <Tab eventKey="milestones" title="Milestones">
          <Milestone allMilstones={props.allMilstones} dealObj={props.dealObj} eventKey={key} projectId={DealsId} />
       
        </Tab> */}
                {/* <Tab eventKey="timesheet" title="Timesheet">
       
          Timesheet
        </Tab>
        <Tab eventKey="issues" title="Issues">
          Issues
        </Tab>
        <Tab eventKey="activity" title="Activities">
          All Task Activities
        </Tab> */}
            </Tabs>
        </div>
    );
};

export default ClientProgress;
